import classnames from "classnames";
import { Collapse } from "react-collapse";
import { createUseStyles } from "react-jss";

type CollapsedProps = {
  className?: string;
  isOpened: boolean;
  children: React.ReactNode;
};

type StylesProps = {
  isOpened: boolean;
};

const useStyles = createUseStyles({
  collapsed: {
    "& .ReactCollapse--collapse": {
      height: (props: StylesProps) => props.isOpened && ["auto", "!important"],
      transition: ["height", "300ms", "ease"],
    },
  },
});

export const Collapsed = ({ className, isOpened, children }: CollapsedProps) => {
  const classes = useStyles({ isOpened });
  return (
    <div className={classnames(classes.collapsed, className)}>
      <Collapse isOpened={isOpened} style={{ color: "red" }}>
        {children}
      </Collapse>
    </div>
  );
};
